import {
  getRaindropEnvironment,
  isProductionEnvironment,
} from "../../services/environment";

const EnvironmentDisplay = () => {
  if (isProductionEnvironment()) {
    return null;
  }

  const environment = getRaindropEnvironment();

  let borderColor = "border-color-dark-text-secondary";
  let textColor = "text-color-dark-text-secondary";
  let opacity = "opacity-100";

  return (
    <div
      id="environment-display"
      className={`flex p-3 w-min h-5 border-2 rounded-md justify-center items-center  ${textColor} ${borderColor} ${opacity} uppercase font-black`}
    >
      {environment}
    </div>
  );
};

export default EnvironmentDisplay;
